import { createClient } from '@supabase/supabase-js';

// Singleton Supabase client. Lazily initialized so local-only (Practice vs AI)
// mode can run without any env vars configured.

let client = null;
let anonymousReady = null;

export function supabaseConfigured() {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  return Boolean(url && key && url.startsWith('https://'));
}

export function getSupabase() {
  if (client) return client;
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url || !key) throw new Error('supabase_not_configured');
  client = createClient(url, key, {
    auth: { autoRefreshToken: true, persistSession: true },
    realtime: { params: { eventsPerSecond: 8 } },
  });
  return client;
}

// Ensures the caller has an anonymous session. Idempotent across calls.
export async function ensureAnonSession() {
  const db = getSupabase();
  if (anonymousReady) return anonymousReady;
  anonymousReady = (async () => {
    const { data } = await db.auth.getSession();
    if (data.session) return data.session.user;
    const { data: signed, error } = await db.auth.signInAnonymously();
    if (error) throw error;
    return signed.user;
  })();
  return anonymousReady;
}
